import React, { useState, useEffect } from 'react';
import { useWebSocket } from '../hooks/useWebSocket';
import { Users, QrCode } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const GameLobby = () => {
  const [usersCount, setUsersCount] = useState(0);
  const { lastMessage } = useWebSocket();

  useEffect(() => {
    if (!lastMessage) return;
    
    if (lastMessage.type === 'game_state' && lastMessage.users_count !== undefined) {
      setUsersCount(lastMessage.users_count);
    }
  }, [lastMessage]);

  const joinUrl = `${BACKEND_URL}/p/game`;

  return (
    <div className="fullscreen" data-testid="game-lobby-screen">
      <div className="wave-background" />
      
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="text-center max-w-2xl px-8">
          <h1 className="text-5xl md:text-7xl font-bold text-white font-['Outfit'] mb-4">
            Join the Game
          </h1>
          <p className="text-xl md:text-2xl text-slate-400 mb-12">
            Scan QR code or visit the URL on your phone
          </p>
          
          {/* QR Code Placeholder */}
          <div className="w-64 h-64 bg-white rounded-3xl mx-auto mb-8 flex items-center justify-center shadow-2xl shadow-blue-500/20">
            <div className="text-center">
              <QrCode size={120} className="text-slate-800 mx-auto mb-2" />
              <div className="text-sm text-slate-600 font-medium">Scan to Join</div>
            </div>
          </div>

          {/* Join URL */}
          <div className="operator-card p-4 mb-12">
            <p className="text-sm text-slate-400 mb-2">Or visit:</p>
            <p className="text-lg text-blue-400 font-mono break-all">{joinUrl}</p>
          </div>

          {/* Players count */}
          <div className="flex items-center justify-center gap-4 text-3xl">
            <div className="w-16 h-16 rounded-full bg-blue-500/20 flex items-center justify-center">
              <Users size={32} className="text-blue-400" />
            </div>
            <div>
              <div className="text-5xl font-bold text-white font-['Outfit']" data-testid="lobby-users-count">
                {usersCount}
              </div>
              <div className="text-slate-400">Players Joined</div>
            </div>
          </div>
        </div>
      </div>

      {/* Animated dots */}
      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 flex gap-2">
        {[0, 1, 2].map(i => (
          <div 
            key={i}
            className="w-3 h-3 rounded-full bg-blue-500"
            style={{
              animation: `pulse 1.5s ease-in-out ${i * 0.3}s infinite`
            }}
          />
        ))}
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 0.3; transform: scale(0.8); }
          50% { opacity: 1; transform: scale(1.2); }
        }
      `}</style>
    </div>
  );
};

export default GameLobby;
